<template>
  <div class="scmcc-custom-object-handle">
    <CTable
      ref = "CTable"
      show-total
      show-elevator
      :views="views"
      :columns="tableColumns"
      :data="tableData"
      :total="total"
      :editCustomObj="editCustomObj"
      :removeCustomObj="removeCustomObj"
      :viewCustomObj="viewCustomObj"
      :editCustomBtn="editCustomBtn"
      :removeCustomBtn="removeCustomBtn"
      :viewCustomBtn="viewCustomBtn"
      show-sizer
      :current = "currentPage"
      :page-size="pageSize"
      @on-change="pageChange"
      @on-page-size-change="pageChangeSize"
      @on-view-change="viewChange"
      @viewObjectDetail="viewObjectDetail"
      @editObjectDetail="editObjectDetail"
      @deleteObjectDetail="deleteObjectDetail"
      @clickFlowRow="clickFlowRow"
      :viewTypeId="viewId"
      stripe
      @on-sort-change="_sortchange"
      @on-selection-change="_selectionChange"
    >
      <template v-slot:tableTop>
        <div class="scmd-handle-div" style = "z-index:99;position:absolute;width:100%;top:0;left:0;" v-show="selectMtIds.length">
          <Checkbox
                  :indeterminate="(selectMtIds.length<tableData.length)"
                  :value="(selectMtIds.length==tableData.length)"
                  @click.prevent.native="_handleCheckAll"
          ></Checkbox>
          已选择【{{ selectMtIds.length }}】项
          <!-- <Button
                  type="text"
                  v-if="removeCustom"
                  class="openOrCloseWork"
                  @click="batchDelete()"
          >删除
          </Button> -->
          <Button
                  type="text"
                  class="openOrCloseWork"
                  @click="_batchExport()"
          >导出
          </Button>
        </div>
      </template>
      <template v-slot:operatingBottom>
        <div>
          <formMix ref = "mixForm" @change = "searchFieldChange" :viewId = "viewId" :viewType = "viewType" :moId = "objId" v-if = "viewId" />
        </div>
      </template>
      <template v-slot:operatingRight>
        <ButtonGroup>
          <Button v-if = "isShowImportBtn" @click = "_import">导入</Button>
          <Button v-if = "isShowExportBtn" @click = "_export">导出</Button>
          <Button
            v-show="isShowNewObject || flowIsShowNewObject"
            @click="slideVisible = !slideVisible"
            style="position:relative;"
          >
            <span>新建</span>
            <Dropdown
              style="position:absolute;top:100%;"
              trigger="custom"
              :visible="slideVisible"
            >
              <DropdownMenu slot="list">
                <DropdownItem
                  :key="index"
                  v-for="(item, index) in businesses"
                  ><div @click="selectBusiness(item)">
                    {{ item.sbtName }}
                  </div></DropdownItem
                >
              </DropdownMenu>
            </Dropdown>
          </Button>
          <Button
            v-if="showCustomBtn"
            @click="slideVisibleCustom = !slideVisibleCustom"
            style="position:relative;"
          >
            <span>...</span>
            <Dropdown
              style="position:absolute;top:100%;"
              trigger="custom"
              :visible="slideVisibleCustom"
            >
              <DropdownMenu slot="list">
                <DropdownItem
                  :key="index"
                  v-for="(item, index) in customButtons"
                  ><div @click="commonMethod(item)">
                    {{ item.btnName }}
                  </div></DropdownItem
                >
              </DropdownMenu>
            </Dropdown>
          </Button>
        </ButtonGroup>
        <!-- <Dropdown
          @on-click="selectBusiness"
          v-show="isShowNewObject || flowIsShowNewObject"
        >
          <Button type="primary" :disabled="businesses.length === 0">
            <span>
              新建
              <Icon type="ios-more" size="30" />
            </span>
          </Button>
          <template v-if="businesses.length > 0">
            <DropdownMenu slot="list">
              <DropdownItem
                v-for="item in businesses"
                :key="item.sbtId"
                :name="item"
                >{{ item.sbtName }}</DropdownItem
              >
            </DropdownMenu>
          </template>
        </Dropdown> -->

        <!-- <Dropdown
          trigger="click"
          style="margin-left: 10px"
          v-if="showCustomBtn"
        >
          <Button type="primary">
            <span>
              自定义按钮
              <Icon type="ios-more" size="30" />
            </span>
          </Button>
          <DropdownMenu slot="list">
            <DropdownItem
              v-for="(item, index) in customButtons"
              @click.native="commonMethod(item)"
              :key="index"
            >
              {{ item.btnName }}
            </DropdownItem>
          </DropdownMenu>
        </Dropdown> -->
      </template>
    </CTable>

    <!-- 新建编辑操作 -->
    <Drawer
      v-model="editDrawerStatus"
      v-if = 'editDrawerStatus'
      :title="titleName"
      width="500"
      :transfer="false"
      className="DrawerStyle"
    >
      <div class="drawer-content">
        <objectAddOrEdit
          v-if="editDrawerStatus"
          class="left"
          ref="objectAddOrEdit"
          :isApproveOpinionShow = "true"
          :data="{
            isFlowType: currentBusiness.isFlowType,
            tenantId: tenantId,
            moId: objectId,
            rowId: currentBusiness.rowId,
            mtId: currentBusiness.mtId,
            busType: currentBusiness.sbtId,
            modelId: currentBusiness.flowModelId,
            isApprovePage: true
          }"
          @on-success="onEditSuccess"
        ></objectAddOrEdit>
      </div>

      <div class="cmsc-drawer-footer">
        <template
          v-if="
            currentBusiness.isFlowType === '0' &&
              currentBusiness.ctype != 'edit'
          "
        >
          <Button class="handle-item" @click="editCancel">取消</Button>
          <Button class="handle-item" type="primary" @click="editSubmit"
            >保存</Button
          >
        </template>
        <template
          v-else-if="
            currentBusiness.isFlowType === '0' &&
              currentBusiness.ctype === 'edit'
          "
        >
          <Button class="handle-item" @click="editCancel">取消</Button>
          <Button class="handle-item" type="primary" @click="editObjectSubmit"
            >保存</Button
          >
        </template>
        <template v-else>
          <Button class="handle-item" @click="editCancel">取消</Button>
          <Button
            class="handle-item"
            type="primary"
            @click="editSubmit({ state: '1' })"
            >暂存</Button
          >
          <Button
            class="handle-item"
            type="primary"
            @click="editSubmit({ state: '2' })"
            >提交</Button
          >
        </template>
      </div>
    </Drawer>
    <!-- 处理操作 -->
    <Drawer
      v-model="handleDrawerStatus"
      title="处理"
      width="800"
      :transfer="false"
      className="DrawerStyle"
    >
      <div class="drawer-content">
        <div
          style="padding-right:10px;height:100%;overflow-y:auto;width:500px;"
        >
          <objectAddOrEdit
            v-if="handleDrawerStatus"
            class="left"
            ref="objectAddOrEdit"
            :data="{
              isFlowType: handleBusiness.isFlowType,
              moId: objectId,
              tenantId: handleBusiness.tenantId,
              mtId: handleBusiness.mtId,
              rowId: handleBusiness.rowId,
              busType: handleBusiness.sbtId,
              flowInstanceId: handleBusiness.flowInstanceId,
              modelId: handleBusiness.flowModelId,
              taskId: currentTaskId,
              isApprovePage: true
            }"
            @on-success="onHandleSuccess"
          ></objectAddOrEdit>
        </div>
        <div class="right" style="width:310px">
          <Tabs value="name1">
            <TabPane label="审批意见" name="name1">
              <div ref="flowOpinion">
                <component
                  :is="$store.state.dynamicComponent.DIYLAYOUT['flowOpinion']"
                />
              </div>
            </TabPane>
            <TabPane label="流程日志" name="name2" v-if="flowLogCon">
              <div ref="flowLog">
                <component
                  :is="$store.state.dynamicComponent.DIYLAYOUT['flowLog']"
                />
              </div>
            </TabPane>
            <TabPane
              label="流转图"
              name="name3"
              v-if="flowGrawCon"
            >
              <div ref="flowDiagram"  :style="styles">
                <component
                  :is="$store.state.dynamicComponent.DIYLAYOUT['flowDiagram']"
                />
              </div>
            </TabPane>
          </Tabs>
        </div>
      </div>

      <div class="cmsc-drawer-footer">
        <Button
          style="margin-right:8px;"
          class="item"
          @click="flowHandleCancel"
          >取消</Button
        >
        <!--<Button class="item" type="primary" @click="handleButton({id: 'EndProcess'})">结束</Button>-->
        <Button
          v-for="item in flowHandleButtons"
          style="margin-right:8px;"
          :key="item.id"
          type="primary"
          class="item"
          @click="handleButton(item)"
          >{{ item.name }}</Button
        >
      </div>
    </Drawer>

    <Modal v-model="returnNodeModel" title="请选择退回节点">
      <RadioGroup v-model="returnNodeValue" vertical>
        <Radio :label="item" :key="item" v-for="item in returnNodeList">
          <Icon type="social-apple"></Icon>
          <span>{{ item.taskName }}</span>
        </Radio>
      </RadioGroup>
      <div slot="footer">
        <Button size="large" @click="returnNodeModel = false">取消</Button>
        <Button size="large" @click="returnNodeSure">提交</Button>
      </div>
    </Modal>

    <Modal v-model="nextUserModel" title="请选择下一处理节点信息">
      <PacketSelector
        :expand = "true"
        style="width: 350px"
        :options="nextAssignList"
        v-model="nextUserValue"
        ref="packetSelectorInput"
      ></PacketSelector>
      <div slot="footer">
        <Button size="large" @click="nextUserModel = false">取消</Button>
        <Button size="large" @click="nextUserSure">提交</Button>
      </div>
    </Modal>
    <objExport ref = "objExport" :tableSelection = "selection" :handleDivCon = "false" :viewId = "viewId" :objectId = "objectId" />
    <objExport ref = "objExport1" :tableSelection = "selection" :handleDivCon = "true" :viewId = "viewId" :objectId = "objectId" />
    <objImport @hasImported = "_hasImported" ref = "objImport" :businesses = "businesses" :viewId = "viewId" :objectId = "objectId" />
  </div>
</template>
sortable: item.isSort == '0'?false:'custom',
<script>
import envConst from '../../env-const.js'
import { mConst } from '@/assets/mConst'
//  import formMix from './formMix.vue'
 import objExport from './export.vue'
 import objImport from './import.vue'
function getIndex(str,strpram,index){
  var strValue=str;
  var strValue1="";
  var value=0;
  for(var i =0;i < index;i++){
  strValue1 = strValue.substring(0,strValue.indexOf(strpram));
  strValue = strValue.substring(strValue1.length+1);
  value += (strValue1.length+1);
  }
  return value;
}
export default {
  name: 'customObjectHandle',
  components: {
    //  formMix,
     objExport,
     objImport
  },
  data() {
    return {
      orderBy : "",
      selection: [],
      slideVisibleCustom: false,
      isShowImportBtn: false,
      isShowExportBtn: false,
		currentPage : 1,
      slideVisible: false,
      customTableFiled: {
        main_pro_name: '',
        business_key: '',
        business_type: '',
        create_by: '',
        create_date: '',
        flow_instance_id: '',
        mo_id: '',
        mt_id: '',
        state: '',
        tenant_id: '',
        update_by: '',
        update_date: '',
        field01: '',
        field02: '',
        field03: '',
        field04: '',
        field05: '',
        field06: '',
        field07: '',
        field08: '',
        field09: '',
        field10: '',
        field11: '',
        field12: '',
        field13: '',
        field14: '',
        field15: '',
        field16: '',
        field17: '',
        field18: '',
        field19: '',
        field20: '',
        field21: '',
        field22: '',
        field23: '',
        field24: '',
        field25: '',
        field26: '',
        field27: '',
        field28: '',
        field29: '',
        field30: '',
        field31: '',
        field32: '',
        field33: '',
        field34: '',
        field35: '',
        field36: '',
        field37: '',
        field38: '',
        field39: '',
        field40: '',
        field41: '',
        field42: '',
        field43: '',
        field44: '',
        field45: '',
        field46: '',
        field47: '',
        field48: '',
        field49: '',
        field50: '',
        field51: '',
        field52: '',
        field53: '',
        field54: '',
        field55: '',
        field56: '',
        field57: '',
        field58: '',
        field59: '',
        field60: '',
        field61: '',
        field62: '',
        field63: '',
        field64: '',
        field65: '',
        field66: '',
        field67: '',
        field68: '',
        field69: '',
        field70: '',
        field71: '',
        field72: '',
        field73: '',
        field74: '',
        field75: '',
        field76: '',
        field77: '',
        field78: '',
        field79: '',
        field80: '',
        field81: '',
        field82: '',
        field83: '',
        field84: '',
        field85: '',
        field86: '',
        field87: ''
      },
      editObjectDetailModel: false,
      customButtons: [],
      editCustomObj: false,
      removeCustomObj: false,
      viewCustomObj: false,
      viewCustomBtn: false,
      editCustomBtn: false,
      removeCustomBtn: false,
      showCustomBtn: false,
      isShowNewObject: false,
      flowIsShowNewObject: false,
      titleName: '新建',
      method: 'insert',
      nextUserModel: false,
      nextAssignList: [],
      flowState: '',
      handleName: '',
      returnNodeValue: '',
      returnNodeModel: false,
      returnNodeList: [],
      currentTaskId: '',
      flowGrawCon: false,
      flowLogCon: false,
      nextUserValue: [],
      viewId: '',
      viewType: '',
      objId: '',
      currentBusiness: {},
      handleBusiness: {},
      rowId: null,
      isFlowType: '0',
      ApproveTaskDate: {
        addApproveTaskDate: {
          nextUserId: '',
          processDefinitionId: '',
          outgoingId: '',
          currnetUserId: '',
          approveOpinion: '',
          currentTaskId: '',
          processInstanceId: '',
          nextGroup: '',
          taskDefinitionKey: '',
          formData: {}
        },
        customFieldDate: [],
        taskState: '',
        transmitUserId: '',
        mtId: ''
      },
      nextAssignUser: [],
      nextAssignOrg: [],
      nextAssignRole: [],
      loginUserInfo: {},
      views: [],
      businesses: [],
      businessesEdit: [],
      tableColumns: [],
      tableFlowColumns: [
        /*{
                        title: '流程实例',
                        key: 'flow_instance_id'
                    },*/
        {
          title: '主属性名称',
          key: 'main_pro_name'
        },
        {
          title: '业务类型',
          key: 'business_type'
        },
        {
          title: '状态',
          key: 'state'
        },
        {
          key: 'field136',
          width: 150,
          align: 'left',
          type: '',
          title: '当前处理人',
          fieldCname: 'field136',
          fieldValue: '',
          timeType: '',
          className: 'vCenter',
          render: (h, { row }) => {
            let obj = {
                flow_handle_user: row.flow_user ? row.flow_user : '',
                flow_handle_bumen: row.flow_org ? row.flow_org : '',
                flow_handle_juese: row.flow_role ? row.flow_role : ''
              },
              { flow_handle_user, flow_handle_bumen, flow_handle_juese } = obj,
              userstate,
              bumenstate,
              juesestate,
              tipContent = `${flow_handle_user}${flow_handle_bumen}${flow_handle_juese}`

            if (flow_handle_user === '') {
              userstate = 'none'
              tipContent = `${flow_handle_bumen}${flow_handle_juese}`
            }
            if (flow_handle_bumen === '') {
              bumenstate = 'none'
              tipContent = `${flow_handle_user}${flow_handle_juese}`
            }
            if (flow_handle_juese === '') {
              juesestate = 'none'
              tipContent = `${flow_handle_user}${flow_handle_bumen}`
            }
            return h(
              'Tooltip',
              {
                props: {
                  placement: 'top-start',
                  content: row.field136,
                  transfer: true,
                  maxWidth: 240
                }
              },
              [
                h(
                  'div',
                  {
                    style: {
                      overflow: 'hidden',
                      whiteSpace: 'nowrap',
                      textOverflow: 'ellipsis'
                    }
                  },
                  [
                    h('CIcon', {
                      class: 'iconFlow',
                      props: {
                        icon: 'tongyong-chengyuan',
                        size: '14'
                      },
                      style: {
                        marginRight: '5px',
                        display: userstate
                      }
                    }),
                    h('span', flow_handle_user),
                    h('CIcon', {
                      class: 'iconFlow',
                      props: {
                        icon: 'caidan-bumenyonghuguanli',
                        size: '14'
                      },
                      style: {
                        marginRight: '5px',
                        display: bumenstate
                      }
                    }),
                    h('span', flow_handle_bumen),
                    h('CIcon', {
                      class: 'iconFlow',
                      props: {
                        icon: 'tongyong-bumen',
                        size: '14'
                      },
                      style: {
                        marginRight: '5px',
                        display: juesestate
                      }
                    }),
                    h('span', flow_handle_juese)
                  ]
                )
              ]
            )
          }
        },
        {
          key: 'field137',
          width: 150,
          align: 'left',
          type: '',
          title: '参与人',
          fieldCname: 'field137',
          fieldValue: '',
          timeType: '',
          className: 'vCenter',
          render: (h, { row }) => {
            let obj = {
                flow_handle_user: row.flow_user_name ? row.flow_user_name : '',
                flow_handle_bumen: row.flow_org_name ? row.flow_org_name : '',
                flow_handle_juese: row.flow_role_name ? row.flow_role_name : ''
              },
              { flow_handle_user, flow_handle_bumen, flow_handle_juese } = obj,
              userstate,
              bumenstate,
              juesestate,
              tipContent = `${flow_handle_user}${flow_handle_bumen}${flow_handle_juese}`

            if (flow_handle_user === '') {
              userstate = 'none'
              tipContent = `${flow_handle_bumen}${flow_handle_juese}`
            }
            if (flow_handle_bumen === '') {
              bumenstate = 'none'
              tipContent = `${flow_handle_user}${flow_handle_juese}`
            }
            if (flow_handle_juese === '') {
              juesestate = 'none'
              tipContent = `${flow_handle_user}${flow_handle_bumen}`
            }
            return h(
              'Tooltip',
              {
                props: {
                  placement: 'top-start',
                  content: row.field137,
                  transfer: true,
                  maxWidth: 240
                }
              },
              [
                h(
                  'div',
                  {
                    style: {
                      overflow: 'hidden',
                      whiteSpace: 'nowrap',
                      textOverflow: 'ellipsis'
                    }
                  },
                  [
                    h('CIcon', {
                      class: 'iconFlow',
                      props: {
                        icon: 'tongyong-chengyuan',
                        size: '14'
                      },
                      style: {
                        marginRight: '5px',
                        display: userstate
                      }
                    }),
                    h('span', flow_handle_user),
                    h('CIcon', {
                      class: 'iconFlow',
                      props: {
                        icon: 'caidan-bumenyonghuguanli',
                        size: '14'
                      },
                      style: {
                        marginRight: '5px',
                        display: bumenstate
                      }
                    }),
                    h('span', flow_handle_bumen),
                    h('CIcon', {
                      class: 'iconFlow',
                      props: {
                        icon: 'tongyong-bumen',
                        size: '14'
                      },
                      style: {
                        marginRight: '5px',
                        display: juesestate
                      }
                    }),
                    h('span', flow_handle_juese)
                  ]
                )
              ]
            )
          }
        },
        {
          title: '是否超时',
          key: 'overtime'
        },
        {
          title: '创建人',
          key: 'create_by'
        },
        {
          title: '创建日期',
          key: 'create_date'
        },
        {
          title: '操作',
          // fixed: 'right',
          width: 100,
          slot: 'flowAction'
          /*  render: (h, params) =>
                    h(
                        'Button',
                        {
                            props: {
                                type: 'text'
                            },
                            on: {
                                click: () => {
                                this.clickFlowRow(params.row)
                        }
            }
        },
            this.viewId=='1'?(params.row.state_id=='1'?'编辑':'详情'):(this.viewId=='2'?(params.row.state_id=='1'?'编辑':'处理'):(this.viewId=='4' || this.viewId=='3')?'详情':'详情')
        )*/
        }
      ],
      processComments: [],
      tableData: [],
      editDrawerStatus: false,
      handleDrawerStatus: false,
      pageSize: 10,
      pageNum: 1,
      total: 0,
      flowHandleButtons: [],
      customColumnData: {
        OBJECT_NAME: '',
        value: {}
      },
      opinions: [
        {
          id: 'department',
          label: h => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-apps'
                }
              }),
              h('span', '部门')
            ])
          },
          list: [],
          type: 'tree'
        },
        {
          id: 'role',
          label: h => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-people'
                }
              }),
              h('span', '角色')
            ])
          },
          type: 'checkbox',
          list: []
        },
        {
          id: 'user',
          label: h => {
            return h('div', [
              h('Icon', {
                props: {
                  type: 'ios-person'
                }
              }),
              h('span', '用户')
            ])
          },
          type: 'checkbox',
          list: []
        }
      ]
    }
  },
  computed: {
    objectId() {
      return this.$route.query.objectId
    },
    tenantId() {
      return this.$store.state.main.user.info.tenantId
    },
    styles() {
      return {
        height: document.body.clientHeight - 190 + 'px'
      }
    },
    selectMtIds(){
      return this.selection.map((item) => {
        return item.mt_id
      })
    }
  },
  watch: { 
    $route(n, o) {
      if (n !== o) {
        n.meta.title = n.query.objectName 
        this.getViewsAndBusinessTypeByObjectId(n.query.objectId)
        this.getLayOutBtn()
      }
    }
  },
  created() {
    this.$route.meta.title = this.$route.query.objectName
    this.getViewsAndBusinessTypeByObjectId(this.objectId)
    this.getUserInfoFromSession()
    this.getfieldMainProperty(this.objectId)
  },
  methods: {
    _handleCheckAll(){
      if(this.selectMtIds.length==this.tableData.length){
        this.$refs["CTable"]&&this.$refs["CTable"].selectAll(false)
      }else{
        this.$refs["CTable"]&&this.$refs["CTable"].selectAll(true)
      }
    },
    _batchExport(){
      this.$refs['objExport1']&&this.$refs['objExport1'].open()
    },
    _selectionChange(selection){//选中变化事件
      console.log(selection)
      this.selection = selection
    },
    _hasImported(){
      this.getTableData()
    },
    _import(){
      this.$refs['objImport']&&this.$refs['objImport'].open(this.businesses)
    },
    _export(){
      this.$refs['objExport']&&this.$refs['objExport'].open()
    },
    _makeQuerySql(params){
      debugger
      let str = ""
      let num = ""
      for(let i in params){
        if(params[i].value||params[i].value === 0){
          if(
            params[i].fieldType == "5"||
            params[i].fieldType == "6"||
            params[i].fieldType == "7"||
            params[i].calcResultType == "6"||
            params[i].calcResultType == "7"
          ){
            num = `${num} & ${i} between ${params[i].value['min']} and ${params[i].value['max']}`
          }else if(params[i].fieldType == "10"){
            str = `${str} and ${i} = ${params[i].value}`
          }else{
            str = `${str} and ${i} like ${params[i].value}`
          }
        }
      }
      let pam = "";
      if(num === ""){
        pam = str;
      }else{
        pam = str + "@"+ num;
      }
      return pam
    },
    _sortchange({column,key,order}){//排序改变
      console.log(column,key,order)
      this.getTableData(`${key} ${order}`)
      this.orderBy = `${key} ${order}`;
    },
    searchFieldChange(params){//筛选事件
      this.orderBy = "";
      this.pageChange(1);
    },
    getfieldMainProperty(moId) {
      this.$http
        .get(envConst.API_BASE_URL + '/scmd/fields/getList', {
          params: { moId, itsProperties: '0' }
        })
        .then(response => {
          if (response.data.returnCode === 0) {
            let objTable = response.data.beans[0]
            let obj = {
              title: objTable.fieldName,
              key: objTable.fieldCname,
              renderHeader: (h, params) => {
                  return h('span', [
                    h('Tooltip', {
                      props: {
                      placement: "top-start",
                        content: objTable.fieldName,
                        transfer: true,
                        maxWidth: '240'
                      }
                    }, [
                      h('span',objTable.fieldName.length>8?objTable.fieldName.substring(0,8)+"...":objTable.fieldName)
                    ]),
                  ])
              },
            }
            Object.assign(this.tableFlowColumns[0], obj)
          } else {
            this.$Message.error('数据查询失败!')
          }
        })
    },
    nextUserSure() {
      if (this.nextUserValue.length == 0) {
        this.$Message.warning('请选择要下一节点信息')
        return false
      } else if (this.nextUserValue.length > 1) {
        this.$Message.warning('部门、角色、用户只能选择一个')
        return false
      }
      this.ApproveTaskDate.addApproveTaskDate.nextGroup = this.nextUserValue[0]
      this.nextUserModel = false
      if (this.flowState == '' || this.flowState == '1') {
        this.editSubmitData('2')
      } else {
        this.approveTask()
      }
    },
    returnNodeSure() {
      if (this.isNull(this.returnNodeValue)) {
        this.$Message.warning('请选择要退回的节点')
        return false
      }
      this.returnNodeModel = false
      this.ApproveTaskDate.addApproveTaskDate.outgoingId = this.returnNodeValue.id
      this.ApproveTaskDate.addApproveTaskDate.nextGroup = this.returnNodeValue.nextGroup
      this.approveTask()
    },
    // 获取视图和业务列表
    getViewsAndBusinessTypeByObjectId(objectId) {
      this.$http
        .get(
          `${envConst.API_BASE_URL}/scmd/Object/getCustomObjectView?moId=${objectId}`
        )
        .then(({ data }) => {
          if (data.bean.viewList) {
            this.views = data.bean.viewList.map((item, index) => {
              return {
                label: item.viewName,
                value: item.viewId,
                type: item.type,
                moId: item.moId,
                selected: !index
              }
            })
            if (
              this.loginUserInfo.userType != '1' &&
              this.loginUserInfo.userType != '2'
            ) {
              if (this.views.length <= 0) {
                this.$Message.warning('无当前对象视图权限，请联系管理员')
                this.tableColumns = []
                return
              }
            }
          } else {
            this.views = []
            this.tableColumns = []
            this.tableData = []
          }
          if (data.bean.BusinessTypeList) {
            this.businessesEdit = []
            if (
              this.loginUserInfo.userType != '1' &&
              this.loginUserInfo.userType != '2'
            ) {
              this.businesses = data.bean.BusinessTypeList.filter(item => {
                return item.isNew == 1
              })
              this.businessesEdit = data.bean.BusinessTypeList.filter(item => {
                return item.isOperate == 1
              })
            } else {
              this.businesses = data.bean.BusinessTypeList
            }
          } else {
            this.businesses = []
            this.tableColumns = []
            this.tableData = []
            this.businessesEdit = []
          }
        })
    },
    // 选择业务类型
    selectBusiness(currentBusiness) {
      this.slideVisible = false
      this.method = 'insert'
      this.titleName = '新建'
      this.flowState = ''
      // this.currentBusiness.flowModelId = "";
      //this.currentBusiness.sbtId = "";
        console.log('1',currentBusiness)
      this.currentBusiness = JSON.parse(JSON.stringify(currentBusiness));
		console.log('2',this.currentBusiness)
      this.currentBusiness.mtId = ''
      this.currentBusiness.rowId = ''
      this.currentBusiness.ctype = ''
      for (let key in this.ApproveTaskDate.addApproveTaskDate) {
        if (key == 'formData') {
          this.ApproveTaskDate.addApproveTaskDate[key] = {}
        } else {
          this.ApproveTaskDate.addApproveTaskDate[key] = ''
        }
      }
      if (currentBusiness.isFlowType === '1') {
        if (!this.flowIsShowNewObject) {
          this.$Message.warning('该流程业务类型表单无新增权限')
          return
        }
        if (currentBusiness.flowModelId) {
          this.ApproveTaskDate.addApproveTaskDate.processDefinitionId =
            currentBusiness.flowModelId
        } else {
          this.ApproveTaskDate.addApproveTaskDate.processDefinitionId = ''
          this.currentBusiness.flowModelId = ''
          this.$Message.warning('该业务类型未配置流程')
          return
        }
        this.$http
          .get(envConst.API_BASE_URL + '/scmd/models/checkdeployed', {
            params: {
              flowModelId: currentBusiness.flowModelId
            }
          })
          .then(response => {
            if (response.data.returnCode === 0) {
              this.editDrawerStatus = true
            } else {
              this.$Message.error(response.data.returnMessage)
            }
          })
      } else {
        if (!this.isShowNewObject) {
          this.$Message.warning('该业务类型表单无新增权限')
          return
        }
        this.ApproveTaskDate.addApproveTaskDate.processDefinitionId = ''
        this.editDrawerStatus = true
      }
    },
    // 修改页码
    pageChange(pageNum) {
    	this.currentPage = pageNum;
      this.updatePaging({ pageNum })
      this.getTableData()
    },
    pageChangeSize(pageSize) {
      this.updatePaging({ pageSize })
      if (this.pageNum == 1) {
        this.getTableData()
      }
    },
    // 改变视图
    viewChange(view) {
      this.viewType = view.type
		  this.viewId = view.value
      this.objId = view.moId
      this.$refs['mixForm']&&this.$refs['mixForm']._resetSync(this.viewId,this.viewType,this.objId)
      this.pageChange(1);
      //this.getTableData()
      if (this.viewType == 'view') {
        this.getLayOutBtn()
      } else {
        this.showCustomBtn = false
        //this.viewId=='1'?(params.row.state_id=='1'?'编辑':'详情'):(this.viewId=='2'?(params.row.state_id=='1'?'编辑':'处理'):(this.viewId=='4' || this.viewId=='3')?'详情':'详情')
      }
    },
    // 获取表格数据
    getTableData(orderBy) {
      this.selection = [] //每次获取表格数据清空选中
      let params = {
        viewId: this.viewId,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      }
      if(this.$refs['mixForm']){
        let whereParam = this.$refs['mixForm']._makeQuerySql(this.$refs['mixForm'].formDatas);
        if(whereParam.indexOf("$")!=-1){
            let whereArr = whereParam.split("$");
            params.whereOf = whereArr[0];
            params.whereOfNum = whereArr[1];
        }else{
            params.whereOf = whereParam;
            params.whereOfNum = "";
        }
      }
      if(this.orderBy){
        params.orderBy = this.orderBy
      }
      if (this.viewType === 'view') {
        this.$http
          .get(
            `${envConst.API_BASE_URL}/scmd/fields/getFieldAndDataListByViewId`,
            {
              params
            }
          )
          .then(({ data }) => {
            // 表头字段处理
            var newArr = data.bean.fieldList
            if (!data.bean.mtIdShow) {
              var fieldCname = 'mt_id'
              newArr = newArr.filter(function(obj) {
                return fieldCname !== obj.fieldCname
              })
            }
            if (!data.bean.businessTypeShow) {
              var fieldCname = 'business_type'
              newArr = newArr.filter(function(obj) {
                return fieldCname !== obj.fieldCname
              })
            }
            console.log(newArr)
            this.tableColumns = newArr.map((item,index) => {
                if(item.fieldCname === 'field136'){
                   return {
                       title: item.fieldName,
                       key: item.fieldCname,
                       sortable: item.isSort == '0'?false:'custom',
                       minWidth: 150,
                       render: (h, { row }) => {
                          let obj = {
                              flow_handle_user: row.flow_user ? row.flow_user : '',
                              flow_handle_bumen: row.flow_org ? row.flow_org : '',
                              flow_handle_juese: row.flow_role ? row.flow_role : ''
                            },
                            { flow_handle_user, flow_handle_bumen, flow_handle_juese } = obj,
                            userstate,
                            bumenstate,
                            juesestate,
                            tipContent = `${flow_handle_user}${flow_handle_bumen}${flow_handle_juese}`

                          if (flow_handle_user === '') {
                            userstate = 'none'
                            tipContent = `${flow_handle_bumen}${flow_handle_juese}`
                          }
                          if (flow_handle_bumen === '') {
                            bumenstate = 'none'
                            tipContent = `${flow_handle_user}${flow_handle_juese}`
                          }
                          if (flow_handle_juese === '') {
                            juesestate = 'none'
                            tipContent = `${flow_handle_user}${flow_handle_bumen}`
                          }
                          return h(
                            'Tooltip',
                            {
                              props: {
                                placement: 'top-start',
                                content: row.field136,
                                transfer: true,
                                maxWidth: 240
                              }
                            },
                            [
                              h(
                                'div',
                                {
                                  style: {
                                    overflow: 'hidden',
                                    whiteSpace: 'nowrap',
                                    textOverflow: 'ellipsis'
                                  }
                                },
                                [
                                  h('CIcon', {
                                    class: 'iconFlow',
                                    props: {
                                      icon: 'tongyong-chengyuan',
                                      size: '14'
                                    },
                                    style: {
                                      marginRight: '5px',
                                      display: userstate
                                    }
                                  }),
                                  h('span', flow_handle_user),
                                  h('CIcon', {
                                    class: 'iconFlow',
                                    props: {
                                      icon: 'caidan-bumenyonghuguanli',
                                      size: '14'
                                    },
                                    style: {
                                      marginRight: '5px',
                                      display: bumenstate
                                    }
                                  }),
                                  h('span', flow_handle_bumen),
                                  h('CIcon', {
                                    class: 'iconFlow',
                                    props: {
                                      icon: 'tongyong-bumen',
                                      size: '14'
                                    },
                                    style: {
                                      marginRight: '5px',
                                      display: juesestate
                                    }
                                  }),
                                  h('span', flow_handle_juese)
                                ]
                              )
                            ]
                          )
                        }
                 }
                }else if(item.fieldCname === 'field137'){
                     return {
                         title: item.fieldName,
                         key: item.fieldCname,
                         sortable: item.isSort == '0'?false:'custom',
                         minWidth: 150,
                         render: (h, { row }) => {
                            let obj = {
                                flow_handle_user: row.flow_user_name ? row.flow_user_name : '',
                                flow_handle_bumen: row.flow_org_name ? row.flow_org_name : '',
                                flow_handle_juese: row.flow_role_name ? row.flow_role_name : ''
                              },
                              { flow_handle_user, flow_handle_bumen, flow_handle_juese } = obj,
                              userstate,
                              bumenstate,
                              juesestate,
                              tipContent = `${flow_handle_user}${flow_handle_bumen}${flow_handle_juese}`

                            if (flow_handle_user === '') {
                              userstate = 'none'
                              tipContent = `${flow_handle_bumen}${flow_handle_juese}`
                            }
                            if (flow_handle_bumen === '') {
                              bumenstate = 'none'
                              tipContent = `${flow_handle_user}${flow_handle_juese}`
                            }
                            if (flow_handle_juese === '') {
                              juesestate = 'none'
                              tipContent = `${flow_handle_user}${flow_handle_bumen}`
                            }
                            return h(
                              'Tooltip',
                              {
                                props: {
                                  placement: 'top-start',
                                  content: row.field137,
                                  transfer: true,
                                  maxWidth: 240
                                }
                              },
                              [
                                h(
                                  'div',
                                  {
                                    style: {
                                      overflow: 'hidden',
                                      whiteSpace: 'nowrap',
                                      textOverflow: 'ellipsis'
                                    }
                                  },
                                  [
                                    h('CIcon', {
                                      class: 'iconFlow',
                                      props: {
                                        icon: 'tongyong-chengyuan',
                                        size: '14'
                                      },
                                      style: {
                                        marginRight: '5px',
                                        display: userstate
                                      }
                                    }),
                                    h('span', flow_handle_user),
                                    h('CIcon', {
                                      class: 'iconFlow',
                                      props: {
                                        icon: 'caidan-bumenyonghuguanli',
                                        size: '14'
                                      },
                                      style: {
                                        marginRight: '5px',
                                        display: bumenstate
                                      }
                                    }),
                                    h('span', flow_handle_bumen),
                                    h('CIcon', {
                                      class: 'iconFlow',
                                      props: {
                                        icon: 'tongyong-bumen',
                                        size: '14'
                                      },
                                      style: {
                                        marginRight: '5px',
                                        display: juesestate
                                      }
                                    }),
                                    h('span', flow_handle_juese)
                                  ]
                                )
                              ]
                            )
                          }
                   }
                  }else if(item.fieldType === mConst.fieldTypePhoto){
                    return {
                       title: item.fieldName,
                       key: item.fieldCname,
                       sortable: item.isSort == '0'?false:'custom',
                       minWidth: 150,
                       renderHeader: (h, params) => {
                             return h('span', [
                               h('Tooltip', {
                                 props: {
                                 placement: "top-start",
                                   content: params.column.title,
                                   transfer: true,
                                   maxWidth: '240'
                                 }
                               }, [
                                 h('span',params.column.title.length>5?params.column.title.substring(0,5)+"...":params.column.title)
                               ]),
                             ])
                         },
                       render: (h, { row }) => {
                          let _img = row[item.fieldCname];
                          if(_img){
                              let imgs = new Array()//组装成 数组
                              let imgUrls = new Array()//组装成 数组
                              //imgs = _img.split(",");
                              imgs.push(_img.split(",")[0])
                              for(let i=0;i<imgs.length;i++){
                                if(i == 1){
                                  break
                                }
                                if(imgs[i]){
                                    let url = envConst.API_BASE_URL + `/file/filemanage/downloadFileByIdAndName/${imgs[i]}?renameFileName=${new Date().getTime()}-${index+1}-${row._rowIndex+1}-${i+1}`;
                                    imgUrls.push(url)
                                }
                              }
                              console.log('32',imgUrls)
                              console.log('33',row)
                              return imgUrls.map(img=>{
                                return h('CImgPreview',{
                                  attrs: {
                                    src: img,
                                    style: 'width: 45px;height: 45px;'
                                  }
                                })
                              })
                          }else{
                            return h("span", '');
                          }
                      }
                    }
                  }else if(item.fieldType === mConst.fieldTypeArea){
                    return {
                        title: item.fieldName,
                        key: item.fieldCname,
                        sortable: item.isSort == '0'?false:'custom',
                        minWidth: 150,
                         renderHeader: (h, params) => {
                              return h('span', [
                                h('Tooltip', {
                                  props: {
                                  placement: "top-start",
                                    content: params.column.title,
                                    transfer: true,
                                    maxWidth: '220'
                                  }
                                }, [
                                  h('span',params.column.title.length>5?params.column.title.substring(0,5)+"...":params.column.title)
                                ]),
                              ])
                          },
                          render: (h, params) =>{
                            let _val14 = params.row[item.fieldCname]
                            if(!_val14){
                              return h("span",{},"--")
                            }else{
                              let _i = getIndex(_val14,"/",3)
                              let _val141 = _val14
                              _val141 = _val141.substring(0,_i-1).split("/")
                              let _val142 = _val14.substring(_i,_val14.length)
                              let _val143 = _val141.join("")+_val142
                              return h('Tooltip', {
                                  props: {
                                    placement: "top-start",
                                    content: _val143,
                                    transfer: true,
                                    maxWidth: '220'
                                  }
                                }, [
                                h('span',_val143.length>5?_val143.substring(0,5)+"...":_val143)
                              ])
                            }
                          }
                    }
                  }else{
                    return {
                        title: item.fieldName,
                        key: item.fieldCname,
                        sortable: item.isSort == '0'?false:'custom',
                        minWidth: 150,
                         renderHeader: (h, params) => {
                              return h('span', [
                                h('Tooltip', {
                                  props: {
                                  placement: "top-start",
                                    content: params.column.title,
                                    transfer: true,
                                    maxWidth: '220'
                                  }
                                }, [
                                  h('span',params.column.title.length>5?params.column.title.substring(0,5)+"...":params.column.title)
                                ]),
                              ])
                          },
                        render: (h,params)=>{
                        if(params.row[item.fieldCname] && params.row[item.fieldCname].length>5 && item.fieldType!="10" && item.fieldType!="8"){
                          return h('span', [
                              h('Tooltip', {
                                props: {
                                placement: "top-start",
                                  content: params.row[item.fieldCname],
                                  transfer: true,
                                  maxWidth: '220'
                                }
                              }, [
                                h('span', params.row[item.fieldCname].substring(0,5)+"...")
                              ]),
                            ])
                        }else{
                          return h('span', params.row[item.fieldCname]?params.row[item.fieldCname]:"--")
                        }
                      }
                    }
                }
            })
            if(this.isShowExportBtn){
              this.tableColumns.unshift({
                type: 'selection',
                width: 60,
                align: 'center'
              },)
            }
            this.tableColumns.push({
              title: '操作',
              fixed: 'right',
              minWidth: 120,
              slot: 'action'
              /*render: (h, params) =>
									h(
										'Button',
										{
											props: {type: 'text'},
											on: {
												click: () => {
													this.$router.push({
														name: 'scmd-detail',
														query: {
															moId: this.objectId,
															mtId: params.row.mt_id,
															busType: params.row.business_type_id
														}
													})
												}
											}
										},
										'详情'
									)*/
            })
            // 表单数据处理
            //this.updatePaging(data.bean.dataList)
            this.total = data.bean.dataList.total
            this.tableData = data.bean.dataList.list
            newArr.map(item => {
              if(item.fieldType == '8'|| item.fieldCname == 'task_phone'|| item.fieldCname == 'cust_phone'){
                for(let i =0;i<this.tableData.length;i++){
                  this.tableData[i][item.fieldCname] = this.$utils['filterSens'](this.tableData[i][item.fieldCname])
                }
              }
              if(item.fieldType == '15'){
                  for(let i =0;i<this.tableData.length;i++){
                    this.tableData[i]._rowIndex = (i+(this.currentPage*this.pageSize)-this.pageSize) //这里添加该数据的序号
                  }
                }
            })
          })
      } else {
        this.tableColumns = this.tableFlowColumns
        let params = {
             moId: this.objectId,
             pageNum: this.pageNum,
             pageSize: this.pageSize,
             type: this.viewId
           }

        if(this.$refs['mixForm']){
            params.whereOf = this.$refs['mixForm']._makeQuerySql(this.$refs['mixForm'].formDatas);
        }
        this.$http
          .get(
            `${envConst.API_BASE_URL}/scmd/objFlow/getCustomObjFlowDataList`,
            {
              params
            }
          )
          .then(({ data }) => {
            //this.updatePaging(data.bean)
             this.total = data.bean.total
            this.tableData = data.beans
          })
      }
    },
    // 编辑器提交
    editSubmit(params) {
      let state = '1'
      if (params.state == 1) {
        state = '1'
        this.editSubmitData(state)
      } else if (params.state == undefined) {
        state = ''
        this.editSubmitData(state)
      } else {
        state = '2'
        //var customFiled = this.$refs['objectAddOrEdit'].getFormData('customFormData');
        this.$refs['objectAddOrEdit']
          .getFormData('customFormData')
          .then(customFiled => {
            console.log('111', customFiled)
            if (customFiled.returnCode === '0') {
              this.ApproveTaskDate.addApproveTaskDate.formData =
                customFiled.values
              this.getNextAssignUser(state)
            }
          })
      }
    },
    editSubmitData(state) {
      this.$refs['objectAddOrEdit']
        .getFormData('customFormData')
        .then(customFiled => {
          this.editSubmitDataSure(state, customFiled)
        })
    },
    editSubmitDataSure(state, customFiled) {
      //var customFiled = this.$refs['objectAddOrEdit'].getFormData('customFormData');
      if (customFiled.returnCode === '0') {
        var columnObj = customFiled.values
        let approveTaskData = {}
        approveTaskData.nextGroup =
          this.ApproveTaskDate.addApproveTaskDate.nextGroup == undefined
            ? ''
            : this.ApproveTaskDate.addApproveTaskDate.nextGroup
        approveTaskData.approveOpinion = customFiled.approveOpinion
        approveTaskData.formData = columnObj
        approveTaskData.currentTaskId =
          this.ApproveTaskDate.addApproveTaskDate.currentTaskId == undefined
            ? ''
            : this.ApproveTaskDate.addApproveTaskDate.currentTaskId
        approveTaskData.outgoingId =
          this.ApproveTaskDate.addApproveTaskDate.outgoingId == undefined
            ? ''
            : this.ApproveTaskDate.addApproveTaskDate.outgoingId
        approveTaskData.processInstanceId = ''

        columnObj['tenant_id'] = this.loginUserInfo.tenantId
        columnObj['business_type'] = this.currentBusiness.sbtId
        columnObj['create_by'] = this.loginUserInfo.userId
        columnObj['state'] = state
        if (this.method == 'update') {
          columnObj['whereOf'] = { mt_id: this.currentBusiness.mtId }
        }
        var params = {
          Head: {
            moId: this.objectId,
            method: this.method,
            version: 'v1.0'
          },
          Data: [
            {
              state: state,
              moId: this.objectId,
              OBJECT_NAME: customFiled.OBJECT_NAME,
              modelId: this.currentBusiness.flowModelId,
              approveTaskDate: approveTaskData,
              value: columnObj
            }
          ]
        }
        this.$http
          .post(
            `${envConst.API_BASE_URL}/scmd/dynObject/operObjectCheck`,
            params
          )
          .then(response => {
            if (response.data.returnCode == 0) {
              if (!response.data.bean.checkCode) {
                this.$Message.error(response.data.bean.errMsg)
              } else {
                this.$Message.success('保存成功')
                this.onEditSuccess()
              }
            } else {
              this.$Message.error(response.data.returnMessage)
            }
          })
      }
    },
    getNextAssignUser(state) {
      let item = { id: this.nextUserValue[0] }
      if (this.nextUserValue.length > 0) {
        this.$refs['packetSelectorInput'].deleteSelectedItem(item)
      }
      this.$http
        .post(
          envConst.API_BASE_URL + '/scmd/flow/getNextTask',
          this.ApproveTaskDate.addApproveTaskDate
        )
        .then(response => {
          if (response.data.returnCode == 0) {
            //结束节点
            if (response.data.bean.endNode) {
              this.ApproveTaskDate.taskState =
                mConst.workOrder.state.WORK_ORDER_END
            }

            if (
              response.data.bean.userRoleOrgMap &&
              response.data.bean.outgoingId
            ) {
              this.ApproveTaskDate.addApproveTaskDate.outgoingId =
                response.data.bean.outgoingId
              this.nextAssignUser = response.data.bean.userRoleOrgMap.userList
              this.nextAssignOrg = response.data.bean.userRoleOrgMap.orgList
              this.nextAssignRole = response.data.bean.userRoleOrgMap.roleList
              let userList = response.data.bean.userRoleOrgMap.userList
              let orgList = response.data.bean.userRoleOrgMap.orgList
              let roleList = response.data.bean.userRoleOrgMap.roleList

              if (
                this.nextAssignUser.length == 1 &&
                this.nextAssignOrg.length == 0 &&
                this.nextAssignRole.length == 0
              ) {
                this.ApproveTaskDate.addApproveTaskDate.nextGroup =
                  'user_' + this.nextAssignUser[0].userId
                if (state != undefined) {
                  this.editSubmitData(state)
                } else {
                  this.approveTask()
                }
              } else if (
                false &&
                this.nextAssignUser.length == 0 &&
                this.nextAssignOrg.length == 1 &&
                this.nextAssignRole.length == 0
              ) {
                this.ApproveTaskDate.addApproveTaskDate.nextGroup =
                  'dept_' + this.nextAssignOrg[0].orgId
                if (state != undefined) {
                  this.editSubmitData(state)
                } else {
                  this.approveTask()
                }
              } else if (
                this.nextAssignUser.length == 0 &&
                this.nextAssignOrg.length == 0 &&
                this.nextAssignRole.length == 1
              ) {
                this.ApproveTaskDate.addApproveTaskDate.nextGroup =
                  'role_' + this.nextAssignRole[0].roleId
                if (state != undefined) {
                  this.editSubmitData(state)
                } else {
                  this.approveTask()
                }
              } else {
                let options = this.opinions
                options[0].list = []
                options[1].list = []
                options[2].list = []
                const transformTree = (beans, list) => {
                  if (beans.length > 0) {
                    beans.forEach(item => {
                      let obj = {
                        id: `dept_${item.orgId}`,
                        title: item.title,
                        isEdit: item.isEdit,
                        children: []
                      }
                      if (item.children.length > 0)
                        transformTree(item.children, obj.children)

                      list.push(obj)
                    })
                  }
                }
                const transformCheckbox = (beans, type, list) => {
                  if (beans.length > 0) {
                    beans.forEach(item => {
                      list.push({
                        id: `${type}_${item[`${type}Id`]}`,
                        title: item[`${type}Name`]
                      })
                    })
                  }
                }
                const transformCheckboxDept = (beans, type, list) => {
                  if (beans.length > 0) {
                    beans.forEach(item => {
                      list.push({
                        id: `${type}_${item[`orgId`]}`,
                        title: item[`orgName`]
                      })
                    })
                  }
                }
                if (response.data.bean.assignAllUsers || true) {
                  transformTree(orgList, options[0].list)
                  transformCheckbox(roleList, 'role', options[1].list)
                  transformCheckbox(userList, 'user', options[2].list)
                } else {
                  transformCheckboxDept(orgList, 'dept', options[0].list)
                  transformCheckbox(roleList, 'role', options[1].list)
                  transformCheckbox(userList, 'user', options[2].list)
                }
                options[0].type = 'tree'
                // options[0].type = response.data.bean.assignAllUsers
                //   ? 'tree'
                //   : 'checkbox'
                this.nextAssignList = options
                this.nextUserModel = true
              }
            } else {
              this.ApproveTaskDate.addApproveTaskDate.outgoingId = ''
              if (state != undefined) {
                this.editSubmitData(state)
              } else {
                this.approveTask()
              }
            }
          } else {
            this.spinShow = false
            this.$Message.error('获取下一节点信息失败')
          }
        })
        .catch(function(error) {
          console.log('获取下一节点信息异常', error)
          this.$Message.error('流程处理失败，请刷新列表重试')
        })
    },
    // 编辑器取消
    editCancel() {
      this.$refs['objectAddOrEdit'].cancel()
      this.editDrawerStatus = false
    },
    // 流程处理取消
    flowHandleCancel() {
      this.$refs['objectAddOrEdit'].cancel()
      this.handleDrawerStatus = false
    },
    // 更新分页信息
    updatePaging({ pageNum, pageSize, total }) {
      pageNum && (this.pageNum = pageNum)
      pageSize && (this.pageSize = pageSize)
      total && (this.total = total)
    },
    // 编辑保存成功
    onEditSuccess() {
      this.editDrawerStatus = false
      this.getTableData()
    },
    onHandleSuccess() {
      this.flowGrawCon =false
      this.handleDrawerStatus = false
      this.getTableData()
    },
    /**
     * 从session获取登陆人信息
     */
    getUserInfoFromSession: function() {
      let userInfo = JSON.parse(window.localStorage.user)
      this.loginUserInfo = userInfo.info
    },
    clickFlowRow(flowData) {
      this.clearApproveTaskDateValue();
      this.flowState = flowData.state_id == undefined ? '' : flowData.state_id
      this.ApproveTaskDate.addApproveTaskDate.formData['create_by_id']= flowData.create_by_id
      if (flowData.flow_instance_id && this.viewId == '2') {
        this.handleBusiness.isFlowType = '1'
        this.handleBusiness.tenantId = flowData.tenant_id_id
        this.handleBusiness.flowInstanceId = flowData.flow_instance_id
        this.handleBusiness.rowId = flowData.row_id
        this.handleBusiness.sbtId = flowData.business_type_id
        this.handleBusiness.mtId = flowData.mt_id
        this.handleBusiness.flowModelId = flowData.flow_model_id
        // this.getProcessComments(flowData.flow_instance_id)
        //获取节点信息
        this.$http
          .post(
            `${envConst.API_BASE_URL}/scmd/flow/getCurTaskInfo/` +
              flowData.flow_instance_id
          )
          .then(response => {
            if (response.data.returnCode == '0') {
              this.currentTaskId =
                response.data.bean.taskId == undefined
                  ? ''
                  : response.data.bean.taskId
              if (this.currentTaskId == '') {
                this.$Message.warning('获取任务节点失败')
                return
              }
              this.handleDrawerStatus = true
              this.getFlowHandleButton(
                this.currentTaskId,
                flowData.flow_model_id
              )
            } else {
              this.$Message.error(response.data.returnMessage)
            }
          })
          .catch(error => {
            console.error('获取当前节点信息异常', error)
          })
        this.getFlowLogAndOption(
          flowData.flow_model_id,
          flowData.flow_instance_id
        )
      } else if (
        (flowData.state_id == '1' && this.viewId == '1') ||
        (flowData.state_id == '1' && this.viewId == '2')
      ) {
        //暂存
        this.method = 'update'
        this.titleName = '编辑'
        this.currentBusiness.isFlowType = '1'
        this.currentBusiness.ctype = ''
        this.currentBusiness.tenantId = flowData.tenant_id
        this.currentBusiness.flowInstanceId = ''
        this.currentBusiness.rowId = flowData.row_id
        this.currentBusiness.sbtId = flowData.business_type_id
        this.currentBusiness.mtId = flowData.mt_id
        this.currentBusiness.flowModelId = flowData.flow_model_id
        this.ApproveTaskDate.addApproveTaskDate.processDefinitionId = this.currentBusiness.flowModelId
        this.editDrawerStatus = true
      } else if (
        flowData.flow_instance_id &&
        (this.viewId == '1' || this.viewId == '3' || this.viewId == '4')
      ) {
        let vId = this.viewId;
        if(vId === '1'){
            vId = '2'
        }
        this.$eventBus.emit('dynamicComponent/call/scwfWorkOrderDetail', {
          moId:this.objectId,
          row: flowData,
          viewId : vId,
          sourceType: 'custObject',
          calBackFunction: () => {
            this.getTableData()
          }
        })
      } else {
        //详情
        this.$router.push({
          name: 'scmd-detail',
          query: {
            moId: this.objectId,
            mtId: flowData.mt_id,
            busType: flowData.business_type_id
          }
        })
      }
    },
    getFlowLogAndOption(modelId, flowInstanceId) {
      //获取节点流程属性  是否展示审批意见
      this.$http
        .get(
          `${envConst.API_BASE_URL}/scmd/models/getFlowPropertys/` +
            flowInstanceId
        )
        .then(response => {
          if (response.data.returnCode == '0') {
            if (response.data.bean.showdetaillog) {
              this.flowGrawCon = true
              this.flowLogCon = true
              this.$nextTick(() => {
                //调用审批日志全局组建
                this.$eventBus.emit('dynamicComponent/call/diyLayout', {
                  active: true,
                  data: { flow_instance_id: flowInstanceId }
                  // el: this.$refs.flowLog,//DOM节点
                })
              })
            } else {
              this.flowGrawCon = false
              this.flowLogCon = false
              this.$nextTick(() => {
                //调用审批日志全局组建
                this.$eventBus.emit('dynamicComponent/call/diyLayout', {
                  active: true,
                  data: { flow_instance_id: flowInstanceId }
                  // el: this.$refs.flowLog,//DOM节点
                })
              })
            }
          } else {
            this.$Message.error(response.data.returnMessage)
          }
        })
    },
    // 获取实例的审批意见，接收实例id
    getProcessComments(flowInstanceId) {
      this.$http
        .get(
          `${envConst.API_BASE_URL}/scmd/flow/getProcessComments/${flowInstanceId}`
        )
        .then(({ data }) => {
          this.processComments = data.beans
        })
    },
    // 获取流程处理按钮
    getFlowHandleButton(taskId, modelId) {
      this.$http
        .get(envConst.API_BASE_URL + '/scmd/flow/getNodeAttributes', {
          params: {
            taskId: taskId,
            modelId: modelId
          }
        })
        .then(({ data }) => {
          this.flowHandleButtons = data.bean.NodePermissions
        })
    },
    handleButton(item) {
      this.ApproveTaskDate.addApproveTaskDate.processDefinitionId = this.handleBusiness.flowModelId
      this.ApproveTaskDate.modelId = this.handleBusiness.flowModelId
      this.ApproveTaskDate.addApproveTaskDate.processInstanceId = this.handleBusiness.flowInstanceId
      this.ApproveTaskDate.addApproveTaskDate.currentTaskId = this.currentTaskId
      this.ApproveTaskDate.taskId = this.currentTaskId
      this.ApproveTaskDate.addApproveTaskDate.nextGroup = '' //不指定人 提交不需要该参数
      this.ApproveTaskDate.mtId = this.handleBusiness.mtId
      this.ApproveTaskDate.taskState = this.flowState
      //获取自定义字段信息
      //var customFiled = this.$refs['objectAddOrEdit'].getFormData('customFormData');
      this.$refs['objectAddOrEdit']
        .getFormData('customFormData')
        .then(customFiled => {
          console.log('111', customFiled)
          if (customFiled.returnCode === '0') {
            this.ApproveTaskDate.addApproveTaskDate.approveOpinion =
              customFiled.approveOpinion
            for (var key in customFiled.values) {
              //if(this.isNotNull(customFiled.values[key])){
              this.customColumnData.value[key] = customFiled.values[key]
              //}
            }
            this.customColumnData.value[
              'state'
            ] = this.ApproveTaskDate.taskState
           let create_by_id = this.ApproveTaskDate.addApproveTaskDate.formData.create_by_id
            this.ApproveTaskDate.addApproveTaskDate.formData = this.customColumnData.value
            this.ApproveTaskDate.addApproveTaskDate.formData['create_by_id']= create_by_id
            this.customColumnData.OBJECT_NAME = customFiled.OBJECT_NAME
            this.ApproveTaskDate.customFieldDate = []
            this.ApproveTaskDate.customFieldDate.push(this.customColumnData)
            this.$http
              .post(
                envConst.API_BASE_URL + '/scmd/flow/getFlowNodeFieldCheck',
                this.ApproveTaskDate
              )
              .then(response => {
                if (response.data.bean.checkCode) {
                  if (item.id == 'submit') {
                    this.ApproveTaskDate.taskState = '2'
                    this.ApproveTaskDate.handleType = 'submit'
                    this.handleName = '提交'
                    this.getNextAssignUser()
                  } else if (item.id == 'save') {
                    this.ApproveTaskDate.handleType = 'save'
                    this.handleName = '提交'
                    this.approveTask()
                  } else if (item.id == 'submitAndPrint') {
                    //提交并打印
                    if (this.isNull(item.value)) {
                      this.$Message.error('未配置打印模板')
                      return false
                    }
                    this.handleName = '提交'
                    this.ApproveTaskDate.handleType = 'submitAndPrint'
                    this.getNextAssignUser()
                  } else if (item.id == 'Regression') {
                    //回退
                    this.ApproveTaskDate.handleType = 'Regression'
                    this.ApproveTaskDate.taskState = '3'
                    this.handleName = '回退'
                    this.getReturnNodeList()
                  } else if (item.id == 'HandOver') {
                    //转交
                    this.ApproveTaskDate.handleType = 'HandOver'
                    this.handleName = '转交'
                    this.getNextTransmitInfo()
                  } else if (item.id == 'EndProcess') {
                    //结束
                    this.ApproveTaskDate.handleType = 'EndProcess'
                    // this.customColumnData.value['state'] = "5";
                    this.handleName = '结束'
                    this.approveTask()
                  }
                } else {
                  this.$Message.error(response.data.bean.errMsg)
                }
              })
          }
        })
    },
    isNotNull: function(value) {
      if (
        value &&
        value !== undefined &&
        value !== null &&
        value !== '' &&
        value !== ''
      ) {
        return true
      }
      return false
    },
    isNull: function(value) {
      if (typeof value != 'number') {
        if (
          !value ||
          value === undefined ||
          value === null ||
          value === '' ||
          value === ''
        ) {
          return true
        }
      }
      return false
    },
    //转交获取转交信息
    getNextTransmitInfo() {
      let item = { id: this.nextUserValue[0] }
      if (this.nextUserValue.length > 0) {
        this.$refs['packetSelectorInput'].deleteSelectedItem(item)
      }
      this.$http
        .post(
          envConst.API_BASE_URL + '/scmd/flow/getTransmitInfo',
          this.ApproveTaskDate.addApproveTaskDate
        )
        .then(response => {
          if (response.data.returnCode == '0') {
            if (response.data.bean.userRoleOrgMap) {
              let userList = response.data.bean.userRoleOrgMap.userList
              let orgList = response.data.bean.userRoleOrgMap.orgList
              let roleList = response.data.bean.userRoleOrgMap.roleList
              if (
                this.nextAssignUser.length == 1 &&
                this.nextAssignOrg == 0 &&
                this.nextAssignRole == 0
              ) {
                this.ApproveTaskDate.addApproveTaskDate.nextGroup =
                  'user_' + this.nextAssignUser[0].userId
                this.approveTask()
              } else if (
                false &&
                this.nextAssignUser.length == 0 &&
                this.nextAssignOrg == 1 &&
                this.nextAssignRole == 0
              ) {
                this.ApproveTaskDate.addApproveTaskDate.nextGroup =
                  'dept_' + this.nextAssignOrg[0].orgId
                this.approveTask()
              } else if (
                this.nextAssignUser.length == 0 &&
                this.nextAssignOrg == 0 &&
                this.nextAssignRole == 1
              ) {
                this.ApproveTaskDate.addApproveTaskDate.nextGroup =
                  'role_' + this.nextAssignRole[0].roleId
                this.approveTask()
              } else {
                let options = this.opinions
                options[0].list = []
                options[1].list = []
                options[2].list = []
                const transformTree = (beans, list) => {
                  if (beans.length > 0) {
                    beans.forEach(item => {
                      let obj = {
                        id: `dept_${item.orgId}`,
                        title: item.title,
                        isEdit: item.isEdit,
                        children: []
                      }
                      if (item.children.length > 0)
                        transformTree(item.children, obj.children)
                      list.push(obj)
                    })
                  }
                }
                const transformCheckbox = (beans, type, list) => {
                  if (beans.length > 0) {
                    beans.forEach(item => {
                      list.push({
                        id: `${type}_${item[`${type}Id`]}`,
                        title: item[`${type}Name`]
                      })
                    })
                  }
                }
                const transformCheckboxDept = (beans, type, list) => {
                  if (beans.length > 0) {
                    beans.forEach(item => {
                      list.push({
                        id: `${type}_${item[`orgId`]}`,
                        title: item[`orgName`]
                      })
                    })
                  }
                }

                if (response.data.bean.assignAllUsers || true) {
                  transformTree(orgList, options[0].list)
                  transformCheckbox(roleList, 'role', options[1].list)
                  transformCheckbox(userList, 'user', options[2].list)
                } else {
                  transformCheckboxDept(orgList, 'dept', options[0].list)
                  transformCheckbox(roleList, 'role', options[1].list)
                  transformCheckbox(userList, 'user', options[2].list)
                }
                options[0].type = 'tree'
                // options[0].type = response.data.bean.assignAllUsers
                //   ? 'tree'
                //   : 'checkbox'
                this.nextAssignList = options
                this.nextUserModel = true
              }
            } else {
              this.$Message.error('未设置转交人')
            }
          } else {
            this.$Message.error('获取下一节点信息失败')
          }
        })
        .catch(function(error) {
          this.$Message.error('流程处理失败，请刷新列表重试')
        })
    },
    /**
     * 提交流程
     */
    approveTask() {
      let _this = this
      _this.$http
        .post(
          `${envConst.API_BASE_URL}/scmd/flow/approveWorkFlow`,
          _this.ApproveTaskDate
        )
        .then(function(data) {
          if (data.data.returnCode == 0) {
            // 获取需要渲染到页面中的数据
            _this.$Message.success(_this.handleName + '成功')
            if (_this.ApproveTaskDate.handleType === 'submitAndPrint') {
              _this.setPrintTemplate()
            }
            _this.onHandleSuccess()
          } else {
           _this.$Message.error(data.data.returnMessage)
          }
        })
    },
    setPrintTemplate() {
      let sptId = ''
      for (var i = 0; i < this.flowHandleButtons.length; i++) {
        if (this.flowHandleButtons[i].id === 'submitAndPrint') {
          sptId = this.flowHandleButtons[i].value
        }
      }
      if (this.isNull(sptId)) {
        this.$Message.error('未配置打印模板')
        return false
      }
      this.$http
        .get(
          envConst.API_BASE_URL +
            '/scmd/printTemplate/getPrintTemplateBySptId/' +
            sptId
        )
        .then(data => {
          if (data.data.returnCode == 0) {
            if (this.isNull(data.data.bean.tJsondata)) {
              this.$Message.error('打印模板错误')
              return false
            }
            let objectKey = this.customTableFiled

            this.$http
              .get(
                envConst.API_BASE_URL +
                  `/scmd/fields/getFieldDetailByMtId?moId=${this.objectId}&mtId=${this.handleBusiness.mtId}`
              )
              .then(res => {
                if (res.data.returnCode == 0) {
                  this.$http
                    .get(envConst.API_BASE_URL + '/scmd/fields/queryPageList', {
                      params: {
                        moId: this.objectId
                      }
                    })
                    .then(response => {
                      if (response.data.returnCode == 0) {
                        var fileds = response.data.beans
                        var workOrderValue = res.data.beans[0]
                        for (let i = 0; i < fileds.length; i++) {
                          if (
                            fileds[i].fieldType === mConst.fieldTypePhoto &&
                            this.isNotNull(workOrderValue[fileds[i].fieldCname])
                          ) {
                            var photoId = workOrderValue[
                              fileds[i].fieldCname
                            ].split(',')
                            var photoIdStr = ''
                            for (let j = 0; j < photoId.length; j++) {
                              if (this.isNotNull(photoId[j])) {
                                photoIdStr =
                                  photoIdStr +
                                  "<img style='width: 200px;height: auto' src='" +
                                  envConst.API_BASE_URL +
                                  '/file/filemanage/downloadFileById/' +
                                  photoId[j] +
                                  "'/><br/>"
                              }
                            }
                            if (photoIdStr !== '') {
                              photoIdStr = photoIdStr.substr(
                                0,
                                photoIdStr.lastIndexOf('<br/>')
                              )
                            }
                            workOrderValue[fileds[i].fieldCname] = photoIdStr
                          }
                        }
                        objectKey = this.objectKeyAddValue(
                          objectKey,
                          workOrderValue
                        )
                        this.print(objectKey, data.data.bean.tJsondata)
                      }
                    })
                } else {
                  this.$Message.error(res.data.returnMessage)
                }
              })
          } else {
            this.$Message.error(data.data.returnMessage)
          }
        })
        .catch(function(error) {
          console.log('打印异常', error)
        })
    },
    print(fields, htmlString) {
      for (let key in fields) {
        htmlString = htmlString.replace(
          new RegExp(`\{\{${key}\}\}`, 'gm'),
          fields[key]
        )
      }
      let editorDOM = document.querySelector('#editorDOM')
      if (!editorDOM) {
        editorDOM = document.createElement('div')
        editorDOM.id = 'editorDOM'
        document.body.appendChild(editorDOM)
      }
      let editor = UE.getEditor('editorDOM')
      editor.ready(() => {
        editor.setContent(htmlString)
        setTimeout(() => {
          editor.execCommand('print')
        }, 900)
      })
    },
    objectKeyAddValue(objKey, objValue) {
      Object.keys(objValue).forEach(key => {
        objKey[key] = objValue[key]
      })
      return objKey
    },
    getReturnNodeList() {
      this.$http
        .post(
          `${envConst.API_BASE_URL}/scmd/flow/getCurBackNodes/` +
            this.currentTaskId
        )
        .then(response => {
          if (response.data.returnCode == 0) {
            this.returnNodeList = response.data.beans
            if (this.returnNodeList.length > 0) {
              if (this.returnNodeList.length > 1) {
                this.returnNodeModel = true
                this.returnNodeValue = ''
              } else {
                this.ApproveTaskDate.addApproveTaskDate.outgoingId = this.returnNodeList[0].id
                this.ApproveTaskDate.addApproveTaskDate.nextGroup = this.returnNodeList[0].nextGroup
                this.approveTask()
              }
            } else {
              this.$Message.error('未指定退回节点')
            }
          } else {
            this.$Message.error(response.data.returnMessage)
          }
        })
        .catch(error => {
          console.error('获取退回节点异常', error)
        })
    },
    getLayOutBtn() {
      this.$http
        .get(`${envConst.API_BASE_URL}/scmd/listLayout/getLayOutBtn`, {
          params: {
            moId: this.objectId,
            layoutType: 1, //布局类型，0详情、1列表
            usePermission: 'use' //使用权限
          }
        })
        .then(({ data }) => {
          if (data.returnCode == 0) {
            this.customButtons = []
            let layOutBtn = data.bean.layOutBtn
            let flowBtn = data.bean.flowBtn
            this.isShowNewObject = false
            this.removeCustomObj = false
            this.editCustomObj = false
            this.viewCustomObj = false
            for (let i = 0; i < layOutBtn.length; i++) {
              //1自定义按钮 0 默认按钮
              if (layOutBtn[i].btnSysType === '1') {
                this.customButtons.push(layOutBtn[i])
              } else {
                if (layOutBtn[i].btnCode === 'add') {
                  this.isShowNewObject = true
                }
                if (layOutBtn[i].btnCode === 'remove') {
                  this.removeCustomObj = true
                }
                if (layOutBtn[i].btnCode === 'edit') {
                  this.editCustomObj = true
                }
                if (layOutBtn[i].btnCode === 'view') {
                  this.viewCustomObj = true
                }
                if (layOutBtn[i].btnCode === 'import') {
                  this.isShowImportBtn = true
                }
                if (layOutBtn[i].btnCode === 'export') {
                  this.isShowExportBtn = true
                }
              }
            }
            this.flowIsShowNewObject = false
            this.removeCustomBtn = false
            this.editCustomBtn = false
            this.viewCustomBtn = false
            if (
              this.loginUserInfo.userType != '1' &&
              this.loginUserInfo.userType != '2'
            ) {
              for (let i = 0; i < flowBtn.length; i++) {
                //1自定义按钮 0 默认按钮
                if (flowBtn[i].btnSysType != '1') {
                  if (flowBtn[i].btnCode === 'add') {
                    this.flowIsShowNewObject = true
                  }
                  if (flowBtn[i].btnCode === 'remove') {
                    this.removeCustomBtn = true
                  }
                  if (flowBtn[i].btnCode === 'edit') {
                    this.editCustomBtn = true
                  }
                  if (flowBtn[i].btnCode === 'view') {
                    this.viewCustomBtn = true
                  }
                }
              }
            } else {
              this.flowIsShowNewObject = true
              this.removeCustomBtn = true
              this.editCustomBtn = true
              this.viewCustomBtn = true
            }

            if (this.customButtons.length > 0) {
              this.showCustomBtn = true
            } else {
              this.showCustomBtn = false
            }
          }
        })
    },
    commonMethod(btnItem) {
      console.log(btnItem)
      //0打开新页面，1在当前页弹出，2执行JS
      if (btnItem.btnClickBehavior === '0') {
        window.open(btnItem.btnBehaviorContent)
      } else if (btnItem.btnClickBehavior === '1') {
        window.open(btnItem.btnBehaviorContent, '_self')
      }
    },
    viewObjectDetail(row) {
      this.$router.push({
        name: 'scmd-detail',
        query: {
          moId: this.objectId,
          mtId: row.mt_id,
          busType: row.business_type_id,
          objectName: this.$route.query.objectName
        }
      })
    },
    editObjectDetail(row) {
      if (
        this.loginUserInfo.userType != '1' &&
        this.loginUserInfo.userType != '2'
      ) {
        if (this.businessesEdit.length == 0) {
          this.$Message.warning('无权限操作当前业务类型数据')
          return
        } else {
          let flag = false
          for (let i = 0; i < this.businessesEdit.length; i++) {
            if (row.business_type_id == this.businessesEdit[i].sbtId) {
              flag = true
            }
          }
          if (!flag) {
            this.$Message.warning('无权限操作当前业务类型数据')
            return
          }
        }
      }
      this.titleName = '编辑'
      this.currentBusiness.isFlowType = '0'
      this.currentBusiness.ctype = 'edit'
      this.currentBusiness.tenantId = row.tenant_id
      this.currentBusiness.flowInstanceId = ''
      this.currentBusiness.rowId = row.row_id
      this.currentBusiness.sbtId = row.business_type_id
      this.currentBusiness.mtId = row.mt_id
      this.currentBusiness.flowModelId = row.flow_model_id
      this.editDrawerStatus = true
    },
    editObjectSubmit() {
      this.$refs['objectAddOrEdit'].customSubmit()
    },
    deleteObjectDetail(row) {
      if (
        this.loginUserInfo.userType != '1' &&
        this.loginUserInfo.userType != '2'
      ) {
        if (this.businessesEdit.length == 0) {
          this.$Message.warning('无权限操作当前业务类型数据')
          return
        } else {
          let flag = false
          for (let i = 0; i < this.businessesEdit.length; i++) {
            if (row.business_type_id == this.businessesEdit[i].sbtId) {
              flag = true
            }
          }
          if (!flag) {
            this.$Message.warning('无权限操作当前业务类型数据')
            return
          }
        }
      }
      this._handleDele(row.mt_id)
      // this.$Modal.confirm({
      //   title: '确认',
      //   content: '确认删除此条数据？',
      //   onOk: () => {
      //     this._handleDele(row.mt_id)
      //   },
      //   onCancel: () => {}
      // })
    },
    _handleDele(mt_id) {
      this.$http
        .get(`${envConst.API_BASE_URL}/scmd/dynObject/deleteDataByMtId`, {
          params: {
            moId: this.objectId,
            mtId: mt_id
          }
        })
        .then(response => {
          if (response.data.returnCode == 0) {
            if (!response.data.bean.checkCode) {
              this.$Message.error(response.data.bean.errMsg)
            } else {
              this.$Message.success('删除成功')
              this.onEditSuccess()
            }
          } else {
            this.$Message.error(response.data.returnMessage)
          }
        })
    },
    clearApproveTaskDateValue(){
      this.ApproveTaskDate.addApproveTaskDate.formData = {},
      this.handleBusiness = {}
      this.customColumnData.value= {}
    }
},
}
</script>
<style lang="stylus">
.scmcc-custom-object-handle
  padding 24px
  border-radius 6px
  background #fff
  .title
    color #515a6e
    font-size 20px
    line-height 1
    border-left 4px solid #458bf5
    padding-left 9px

  .drawer-content
    display flex
    height 100%

    .left
      flex 0 0 400px

    .right
      flex auto
      border-left 1px solid #ddd
      padding-left 15px

    .process-comments
      .item
        font-size 14px
        padding 15px 0
        border-bottom 1px solid #ddd
</style>
<style scoped lang="stylus">
>>>.DrawerStyle
  .ivu-drawer-body
    position static
    height calc(100% - 95px)

    .cmsc-drawer-footer
      background #fff
</style>
<style scoped>
.icon_1:hover {
  color: #04cbd8;
}
</style>